import { Component, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { environment } from '../environments/environment';
import { RoutePartsService } from './shared/services/route-parts.service';
import { filter, map } from 'rxjs/operators';
import { UILibIconService } from './shared/services/ui-lib-icon.service';
import { LocalStoreService } from './shared/services/local-store.service';
import { GlobalService } from './shared/services/global.service';
import { slideInAnimation } from './shared/animations/animation';

declare var $: any;
declare var DevExpress: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [slideInAnimation],
})
export class AppComponent implements OnInit, AfterViewInit {
  readonly VAPID_PUBLIC_KEY = environment.VAPID_PUBLIC_KEY;
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  titles = 'push-notification';
  message;
  appTitle = '';
  pageTitle = '';
  sockets;
  currentUser: any = {};
  constructor(
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    private iconService: UILibIconService,
    private local: LocalStoreService,
    private globalSrv: GlobalService
  ) {
    iconService.init();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit() {
    try {
      $('#main-progress-bar').hide();
    } catch (error) { }

    this.changePageTitle();
    this.getRouteActive();
  }

  getRouteActive() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activeRoute.firstChild;
          while (child) {
            if (child.firstChild) {
              child = child.firstChild;
            } else if (child.snapshot.data && child.snapshot.data['title']) {
              return {
                title: child.snapshot.data['title'],
                state: child.snapshot['_routerState'].url,
              };
            } else {
              return null;
            }
          }
          return null;
        })
      )
      .subscribe((customData: any) => {
        this.globalSrv.theItem = customData;
      });
  }

  ngAfterViewInit() { }

  changePageTitle() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((routeChange) => {
        if (this.local.getItem('currentUser')) {
          this.appTitle = this.local.getItem('currentUser').companyName;
        } else {
          this.appTitle = '';
        }
        const routeParts = this.routePartsService.generateRouteParts(
          this.activeRoute.snapshot
        );
        if (!routeParts.length) {
          return this.title.setTitle(this.appTitle);
        }
        // Extract title from parts;
        this.pageTitle = routeParts
          .reverse()
          .map((part) => part.title)
          .reduce((partA, partI) => {
            return `${partA} > ${partI}`;
          });
        if (this.appTitle) this.pageTitle += ` | ${this.appTitle}`;
        this.title.setTitle(this.pageTitle);
      });
  }

  ngOnDestroy(): void { }
}
